import React from "react";
import { SFTypography, SFStack, SFUseStyled } from "@sf-core";

const { styled } = SFUseStyled();

const SFStackStyled = styled(SFStack)(() => ({
  height: "100%",
  width: "100%",
  cursor: "pointer",
}));

const SFTypographyBody = styled(SFTypography)(({ theme }) => ({
  whiteSpace: "break-spaces",
  overflow: "hidden",
  display: "-webkit-box",
  WebkitLineClamp: 1,
  WebkitBoxOrient: "vertical",
  textOverflow: "ellipsis",
}));

const ClickCellRenderer = ({
  data,
  labelField,
  onClick,
  variant = "body2",
}) => {
  if (!data) return null;
  return (
    <SFStackStyled justifyContent="center" onClick={() => onClick(data)}>
      <SFTypographyBody variant={variant}>{data.jobName}</SFTypographyBody>
    </SFStackStyled>
  );
};

export default ClickCellRenderer;
